import { themes } from '@clariness/clarikit-tokens';
import { Box, Icon } from '@clariness/clarikit-react';
import { BookIcon } from '@clariness/clarikit-icons';
const { color, space } = themes.light;

export const FAQIcon = () => {
  return (
    <Box
      display="flex"
      width={space['space-64']}
      height={space['space-64']}
      alignItems="center"
      justifyContent="center"
      backgroundColor={color['color-green-tertiary']}
      style={{ borderRadius: space['space-40'] }}
    >
      <Icon source={BookIcon} size="medium" color="color-green-quaternary" />
    </Box>
  );
};
